/**
 * Actions relating to getting/setting configuration parameters for a Sparx
 * Web application, including saving persistent information to browser local
 * storage
 */

export const ADD_CONFIG_PARAMETERS = 'ADD_CONFIG_PARAMETERS';

/**
 * Create an action to add some config parameters to the state, optionally
 * also saving them to browser local storage
 * @param parameters an object containing key-value config parameters
 * @param saveToLocalStorage if true, the config parameters will also be
 * saved to local storage
 * @returns {{type: string, parameters: *, saveToLocalStorage: *}}
 */
export function addConfigParameters(parameters, saveToLocalStorage) {
    return { type: ADD_CONFIG_PARAMETERS, parameters, saveToLocalStorage };
}
